// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#scrollToTopBtn {
        background-color: rgba(170,214,147,255);
        border: none;
        border-radius: 8px;
        color: rgb(0, 0, 0);
        cursor: pointer;
        font-size: 24px;
        line-height: 48px;
        width: 48px;
        position: fixed;
        bottom: 30px;
        right: 30px;
        z-index: 100;
        transition: all .5s ease;
        opacity: 0.5;
      }
#scrollToTopBtn:hover {
    background-color: #555;
}

.to-top {
    bottom: 0;
    cursor: pointer;
    margin: 0 8px 12px 0;
    position: fixed;
    right: 0;
    opacity: 0;
  }
  
  .show-scrollTop {
    opacity: 1 !important;
    transition: all 0.2s ease-in-out;
  }`, "",{"version":3,"sources":["webpack://./src/app/components/backtotop/backtotop.component.css"],"names":[],"mappings":"AAAA;QACQ,uCAAuC;QACvC,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,eAAe;QACf,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,wBAAwB;QACxB,YAAY;MACd;AACN;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,gCAAgC;EAClC","sourcesContent":["#scrollToTopBtn {\r\n        background-color: rgba(170,214,147,255);\r\n        border: none;\r\n        border-radius: 8px;\r\n        color: rgb(0, 0, 0);\r\n        cursor: pointer;\r\n        font-size: 24px;\r\n        line-height: 48px;\r\n        width: 48px;\r\n        position: fixed;\r\n        bottom: 30px;\r\n        right: 30px;\r\n        z-index: 100;\r\n        transition: all .5s ease;\r\n        opacity: 0.5;\r\n      }\r\n#scrollToTopBtn:hover {\r\n    background-color: #555;\r\n}\r\n\r\n.to-top {\r\n    bottom: 0;\r\n    cursor: pointer;\r\n    margin: 0 8px 12px 0;\r\n    position: fixed;\r\n    right: 0;\r\n    opacity: 0;\r\n  }\r\n  \r\n  .show-scrollTop {\r\n    opacity: 1 !important;\r\n    transition: all 0.2s ease-in-out;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
